import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, FileText, History, Settings, Plus } from 'lucide-react';

const tabs = [
  { path: '/dashboard', icon: Home, label: 'Home', end: true },
  { path: '/dashboard/invoices', icon: FileText, label: 'Invoices' },
  { path: '/dashboard/transactions', icon: History, label: 'Transactions' },
  { path: '/dashboard/settings', icon: Settings, label: 'Settings' },
];

const BottomNav = () => {
  return (
    <nav className="bottom-nav" aria-label="Primary">
      <NavLink
        to={tabs[0].path}
        end={tabs[0].end}
        className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
      >
        <Home size={22} />
        <span>{tabs[0].label}</span>
      </NavLink>
      <NavLink
        to={tabs[1].path}
        className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
      >
        <FileText size={22} />
        <span>{tabs[1].label}</span>
      </NavLink>

      {/* Center elevated action: Create Invoice */}
      <NavLink
        to="/dashboard/invoices?action=create"
        className="bottom-nav-fab"
        aria-label="Create invoice"
      >
        <span className="bottom-nav-fab-circle">
          <Plus size={26} />
        </span>
        <span className="bottom-nav-fab-label">Create</span>
      </NavLink>

      <NavLink
        to={tabs[2].path}
        className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
      >
        <History size={22} />
        <span>{tabs[2].label}</span>
      </NavLink>
      <NavLink
        to={tabs[3].path}
        className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
      >
        <Settings size={22} />
        <span>{tabs[3].label}</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav;
